import { jsx as o, jsxs as e } from "react/jsx-runtime";
import { PrevArrow as g, NextArrow as C } from "../CarouselArrows/CarouselArrows.js";
import { ArrowSize as s } from "../CarouselArrows/CarouselArrows.types.js";
import "@material-ui/core/Box";
import "@material-ui/core/Breadcrumbs";
import "@material-ui/core/Button";
import "@material-ui/core/Card";
import "@material-ui/core/CardContent";
import "@material-ui/core/Checkbox";
import "@material-ui/core/CircularProgress";
import "@material-ui/core/Dialog";
import "@material-ui/core/DialogActions";
import "@material-ui/core/DialogContent";
import "@material-ui/core/DialogContentText";
import y from "@material-ui/core/DialogTitle";
import "@material-ui/core/Divider";
import "@material-ui/core/Drawer";
import "@material-ui/core/FormControl";
import "@material-ui/core/FormControlLabel";
import "@material-ui/core/FormGroup";
import "@material-ui/core/FormHelperText";
import S from "@material-ui/core/Grid";
import N from "@material-ui/core/IconButton";
import "@material-ui/core/Input";
import "@material-ui/core/InputAdornment";
import "@material-ui/core/InputBase";
import "@material-ui/core/InputLabel";
import "@material-ui/core/LinearProgress";
import "@material-ui/core/Link";
import "@material-ui/core/ListItemIcon";
import "@material-ui/core/ListItemText";
import "@material-ui/core/Menu";
import "@material-ui/core/MenuItem";
import w from "@material-ui/core/Modal";
import "@material-ui/core/Popover";
import "@material-ui/core/Radio";
import "@material-ui/core/RadioGroup";
import "@material-ui/core/Select";
import "@material-ui/core/styles/createStyles";
import "@material-ui/core/styles/createTheme";
import "@material-ui/core/styles/makeStyles";
import "@material-ui/core/styles/useTheme";
import "@material-ui/core/styles/withStyles";
import "@material-ui/core/styles/withTheme";
import "@material-ui/core/SvgIcon";
import "@material-ui/core/Table";
import "@material-ui/core/TableBody";
import "@material-ui/core/TableCell";
import "@material-ui/core/TableContainer";
import "@material-ui/core/TableHead";
import "@material-ui/core/TableRow";
import "@material-ui/core/TextField";
import "@material-ui/core/Tooltip";
import k from "@material-ui/core/Typography";
import "@material-ui/core/useMediaQuery";
import "@material-ui/icons/Check";
import "@material-ui/icons/CheckCircle";
import "@material-ui/icons/Clear";
import x from "@material-ui/icons/Close";
import "@material-ui/icons/Delete";
import "@material-ui/icons/Error";
import "@material-ui/icons/FiberManualRecord";
import "@material-ui/icons/HelpOutline";
import "@material-ui/icons/Home";
import "@material-ui/icons/Info";
import "@material-ui/icons/KeyboardArrowLeft";
import "@material-ui/icons/KeyboardArrowRight";
import "@material-ui/icons/NavigateNext";
import "@material-ui/icons/OpenInNew";
import "@material-ui/icons/ReportProblem";
import "@material-ui/icons/Schedule";
import "@material-ui/icons/Visibility";
import "@material-ui/icons/VisibilityOff";
import "@material-ui/icons/Warning";
import "@material-ui/lab/Alert";
import "@material-ui/pickers/DatePicker";
import "@material-ui/pickers/MuiPickersUtilsProvider";
import "@material-ui/styles/ThemeProvider";
import { forwardRef as A, useState as I, useImperativeHandle as M } from "react";
import b from "react-dom";
import D from "react-slick";
const mo = A(({ classes: t, options: d, ...c }, f) => {
  const [p, a] = I(!1), u = () => {
    a(!0);
  };
  M(
    f,
    () => ({
      open: u
    }),
    []
  );
  const l = (r) => {
    r.stopPropagation();
  }, h = (r) => {
    const i = b.findDOMNode(r);
    if (!i)
      return;
    const n = i.getElementsByClassName("slick-current").item(0);
    n && n.focus();
  }, v = (r) => r.overlay ? /* @__PURE__ */ o("span", { className: t.overlay, children: r.overlay }) : null, m = () => {
    a(!1);
  };
  return /* @__PURE__ */ o(
    w,
    {
      "data-testid": "carousel-modal",
      open: !!p,
      onEscapeKeyDown: m,
      className: "carousel-modal",
      // The slider needs to get unmounted when the modal is closed for the initialSlide prop to work correctly
      children: p ? /* @__PURE__ */ e("div", { "data-testid": "carousel-backdrop", onClick: m, children: [
        /* @__PURE__ */ o(y, { children: /* @__PURE__ */ o(S, { container: !0, justify: "flex-end", alignItems: "center", children: /* @__PURE__ */ o(N, { onClick: m, children: /* @__PURE__ */ o(x, { htmlColor: "#fff" }) }) }) }),
        /* @__PURE__ */ o(
          D,
          {
            infinite: !0,
            dots: !1,
            useCSS: !1,
            speed: 0,
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: /* @__PURE__ */ o(C, { size: s.medium }),
            prevArrow: /* @__PURE__ */ o(g, { size: s.medium }),
            ref: h,
            ...c,
            children: d.map((r, i) => /* @__PURE__ */ e("div", { "data-testid": `carousel-image-${i}`, children: [
              /* @__PURE__ */ e("div", { className: t.imageContainer, children: [
                v(r),
                /* @__PURE__ */ o(
                  "img",
                  {
                    "data-testid": "img",
                    className: t.modalImage,
                    title: "",
                    alt: "",
                    src: r.src,
                    onClick: l
                  }
                )
              ] }),
              r.caption ? /* @__PURE__ */ o(
                k,
                {
                  "data-testid": "caption",
                  className: t.caption,
                  variant: "body1",
                  onClick: l,
                  children: r.caption
                }
              ) : null
            ] }, r.src))
          }
        )
      ] }) : /* @__PURE__ */ o("div", {})
    }
  );
});
export {
  mo as default
};
//# sourceMappingURL=CarouselModal.js.map
